import React from "react";
import styled from "@emotion/styled";
import { ImpactShopProductImage } from "../../../shared/build/main";
import Image from "next/image";
import { buildDataUrlFromBase64 } from "../utils";

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 360px;
  vertical-align: middle;

  @media ${({ theme }) => theme.bp.tabletUp} {
    height: 480px;
  }

  @media ${({ theme }) => theme.bp.desktopUp} {
    border-right: 1px solid ${({ theme }) => theme.colors.mist};
  }

  @media ${({ theme }) => theme.bp.wideDesktopUp} {
    height: 560px;
  }

  @media ${({ theme }) => theme.bp.veryWideDesktopUp} {
    height: 680px;
  }

  @media ${({ theme }) => theme.bp.extraWideDesktopUp} {
    height: 760px;
  }
`;

const ProjectImage = styled(Image)`
  object-fit: cover;
`;

const CentredBadge = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 180px;
  height: 180px;
`;

export const ImpactShopProductPageImage = ({
  title = "",
  image,
  badgePath,
}: {
  title?: string;
  image: ImpactShopProductImage;
  badgePath?: string;
}) => (
  <ImageContainer>
    <ProjectImage
      alt={`Example ${title} project`}
      blurDataURL={buildDataUrlFromBase64(image.placeholder)}
      fill
      placeholder="blur"
      sizes="(max-width: 767px) 100vw, 75vw"
      src={image.url}
    />
    {badgePath && (
      <CentredBadge>
        <Image src={badgePath} alt={`${title} badge`} fill unoptimized />
      </CentredBadge>
    )}
  </ImageContainer>
);
